/*
用于发起API请求中的用户身份认证token的本地缓存（在http header中通过Authorization字段携带token）
yufu及auth0两种登录方式共用
历史原因暂不修改key值“abc-yufuToken”
*/
export const USER_TOKEN_KEY = 'abc-yufuToken';

// 上一次页面访问的project id的localStorage key
export const LAST_PROJECT_ID = 'lastProjectId';

// 左侧导航
export const ABC_SIDE_NAV_COLLAPSED = 'ABC_SIDE_NAV_COLLAPSED';

// 实验列表筛选类型
export const ABC_EXPERIMENTS_TYPE = 'ABC_EXPERIMENTS_TYPE';

// 实验列表列
export const ABC_EXPERIMENTS_COLUMNS = 'ABC_EXPERIMENTS_COLUMNS';

// 引导用户创建项目
export const INTRO_CREATE_PROJECT_PREFIX = 'ABC_INTRO_CREATE_PROJECT';

// 指标列表展示列
export const METRIC_TABLE_COLUMNS = 'METRIC_TABLE_COLUMNS';

// 数据源列表展示列
export const DATA_SOURCE_TABLE_COLUMNS = 'DATA_SOURCE_TABLE_COLUMNS';

// feature flags 列表筛选类型
export const FEATURE_FLAGS_TYPE = 'FEATURE_FLAGS_TYPE';

// 创建实验表单缓存
export const CREATE_EXPERIMENT_FORM = 'CREATE_EXPERIMENT_FORM';

// 角色权限页的列存储
export const SETTING_ROLE_PERMISSIONS_COLUMNS = 'SETTING_ROLE_PERMISSIONS_COLUMNS';

export const COOKIE_AUTHORIZATION = 'COOKIE_AUTHORIZATION';
